import ClientList from "@/components/Clients/ClientList.vue";
import ClientEdit from "@/components/Clients/ClientEdit.vue";
import ClientFilter from "@/components/Clients/ClientFilter.vue";
import ClientHeader from "@/components/Clients/ClientHeader.vue";


export default [
    {
        path: 'client',
        alias: 'clients',
        name: 'All Clients',
        redirect: "/client/list",
        components: {
            page: ClientList,
            header: ClientHeader
        },
        meta: {
            requiresAuth: false
        },
        children: [
            {
                path: "filter",
                name: "Client Filter",
                components: {
                    modal: ClientFilter
                }
            },
            {
                path: "list/:filter?",
                name: "Client List",
                components: {
                    // ... NONE
                }
            },
            {
                path: "edit/:id",
                name: "Client Edit",
                components: {
                    modal: ClientEdit,
                }
            }
        ]
    }
];